import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      meta: {
        title: 'homeTitle',
      },
      component: function(resolve) {
        require(['@/page/home/home.vue'], resolve)
      },
    },
    {
      path: '/homeItem/:id',
      name: 'homeItem',
      component: function(resolve) {
        require(['@/page/homeItem/homeItem.vue'], resolve)
      },
      children: [{
          path: '/about',
          name: 'about',
          title: 'aboutTitle',
          component: function(resolve) {
            require(['@/page/homeItem/children/about/about.vue'], resolve)
          }
        }, {
          path: '/services',
          name: 'services',
          title: 'servicesTitle',
          component: function(resolve) {
            require(['@/page/homeItem/children/services/services.vue'], resolve)
          }
        }, {
          path: '/joinUS',
          name: 'joinUS',
          title: 'joinUSTitle',
          component: function(resolve) {
            require(['@/page/homeItem/children/joinUS/joinUS.vue'], resolve)
          }
        },
        {
          path: '/contactUS',
          name: 'concatUS',
          title: 'concatUSTitle',
          component: function(resolve) {
            require(['@/page/homeItem/children/concatUS/concatUS.vue'], resolve)
          }
        },
        {
          path: '/news',
          name: 'news',
          title: 'newsTitle',
          component: function(resolve) {
            require(['@/page/homeItem/children/news/news.vue'], resolve)
          }
        },



        // {
        //   path: 'posts',
        //   component: function(resolve) {
        //     require(['@/page/homeItem/homeItem.vue'],resolve)
        //   }
        // }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js